export default "__VITE_ASSET__4Q9qxx$C__"